'use client';

import { useEffect, useState } from 'react';
import BookingPriceBreakdown from '@/components/organisms/booking-price-breakdown/booking-price-breakdown';
import useQueryBookingPriceDetails from '@/integrations/content/content-modules/booking-price-details/booking-price-details.hooks';
import styles from './booking-price-details.module.scss';

export interface BookingPriceDetailsProps {
  /** The UUID of the module */
  id: Content.Components['BookingPriceDetailsHeadlessModuleDto']['id'];
  /** The UUID of the current page */
  pageId: Content.Components['BookingPriceDetailsHeadlessModuleDto']['pageId'];
  /** The parameters for the booking */
  parameters: Content.Components['BookingPriceDetailsHeadlessModuleDto']['parameters'];
}

const BookingPriceDetails = ({
  id,
  pageId,
  parameters,
}: BookingPriceDetailsProps) => {
  const [bookingPriceDetails, setBookingPriceDetails] =
    useState<Content.Properties.BookingPriceDetails>();

  const identifiers = { ...parameters, id, pageId };

  const {
    data: dataBookingPriceDetails,
    isLoading: isLoadingBookingPriceDetails,
    isFetching: isFetchingBookingPriceDetails,
    refetch: refetchBookingPriceDetails,
  } = useQueryBookingPriceDetails({
    parameters: identifiers,
  });

  const hasNoData = !dataBookingPriceDetails && !isFetchingBookingPriceDetails;

  useEffect(() => {
    if (!dataBookingPriceDetails) return;

    setBookingPriceDetails(dataBookingPriceDetails.bookingPriceDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataBookingPriceDetails]);

  useEffect(() => {
    refetchBookingPriceDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (hasNoData) return null;

  return (
    <div className={styles.component}>
      <div className={styles.contentWrapper}>
        <BookingPriceBreakdown
          bookingPriceDetails={bookingPriceDetails}
          identifiers={identifiers}
          isFetching={isFetchingBookingPriceDetails}
          isLoading={isLoadingBookingPriceDetails}
          limit={8}
        />
      </div>
    </div>
  );
};

BookingPriceDetails.displayName = 'BookingPriceDetails';

export default BookingPriceDetails;
